import axios from '../../axios'

/*
 * 招录数据管理接口
 */

// 创建招录信息
export const createZLInfo = data => {
    return axios({
        url: '/api/data/wish/admission',
        method: 'POST',
        data
    })
}

// 编辑招录信息
export const editZLInfo = data => {
    return axios({
        url: '/api/data/wish/admission',
        method: 'PUT',
        data
    })
}

// 获取招录信息详情
export const getZLInfo = data => {
    return axios({
        url: '/api/data/wish/admission/info',
        method: 'GET',
        data
    })
}

// 删除招录信息
export const deleteZLInfo = data => {
    return axios({
        url: '/api/data/wish/admission',
        method: 'DELETE',
        data
    })
}

// 获取招录信息列表
export const getZLInfoList = data => {
    return axios({
        url: '/api/data/wish/admission',
        method: 'GET',
        data
    })
}

// 根据关键词模糊搜素
export const searchBykey = data => {
    return axios({
        url: '/api/data/wish/search/admission/page',
        method: 'GET',
        data
    })
}

// 获取考试大类
export const getExamcategorylist = data => {
    return axios({
        url: '/api/data/wish/examcategory/list',
        method: 'GET',
        data
    })
}

// 获取专业列表
export const getProfList = data => {
    return axios({
        url: '/api/data/wish/examcategory/prof/list',
        method: 'GET',
        data
    })
}

// 获取城市列表
export const getCityList = data => {
    return axios({
        url: '/api/base/city_list',
        method: 'GET',
        data
    })
}

// 模糊搜索学校
export const getSchoolList = data => {
    return axios({
        url: '/api/data/wish/search/school',
        method: 'GET',
        data
    })
}

// 模糊搜索统考类别
export const getCateList = data => {
    return axios({
        url: '/api/data/wish/search/joint/category',
        method: 'GET',
        data
    })
}

// 获取批次
export const getBatchData = data => {
    return axios({
        url: '/api/data/wish/province/batch',
        method: 'GET',
        data
    })
}

// 招录数据导出功能
export const exportTData = data => {
    return axios({
        url: '/api/data/wish/admission/export',
        method: 'POST',
        data
    })
}

// 招录数据导入功能
export const importZLData = data => {
    return axios({
        url: '/api/data/wish/admission/import',
        method: 'POST',
        data
    })
}

// 招录数据导入预检测功能
export const checkZLData = data => {
    return axios({
        url: '/api/data/wish/admission/check',
        method: 'POST',
        data
    })
}
// 招录数据导入预检测功能1-特殊投档
export const checkZLDataSpecial = data => {
    return axios({
        url: '/api/data/wish/admission/chinese/foreign/check',
        method: 'POST',
        data
    })
}
// 招录数据导入预检测功能2-相似专业
export const checkZLDataMajor = data => {
    return axios({
        url: '/api/data/wish/admission/same/prof/check',
        method: 'POST',
        data
    })
}
// 招录数据导入预检测功能3-小分限制
export const checkZLDataAliquot = data => {
    return axios({
        url: '/api/data/wish/admission/small/limit/check',
        method: 'POST',
        data
    })
}

// 招录数据批量更新功能
export const updataZLData = data => {
    return axios({
        url: '/api/data/wish/admission/batch/update',
        method: 'POST',
        data
    })
}

// 招录数据批量删除功能
export const queryDelData = data => {
    return axios({
        url: '/api/data/wish/admission/batch/delete',
        method: 'POST',
        data
    })
}

// 招录数据批量检测院校信息是否一致
export const queryCheckTuition = data => {
    return axios({
        url: '/api/data/wish/admission/check/tuition',
        method: 'POST',
        data
    })
}

// 招录数据批量检测录取分逻辑
export const queryCheckEnroll = data => {
    return axios({
        url: '/api/data/wish/admission/check/enroll/score',
        method: 'POST',
        data
    })
}

// 招录数据大小年录取分对比导出
export const querySmallyear = data => {
    return axios({
        url: '/api/data/wish/admission/small/year/diff/export',
        method: 'POST',
        data
    })
}

// 招录数据大小年投档分对比导出
export const querySmallyearTD = data => {
    return axios({
        url: '/api/data/wish/archive/small/year/diff/export',
        method: 'POST',
        data
    })
}

// 一键清除缓存按钮
export const cleanCache = data => {
    return axios({
        url: '/api/data/wish/clean/cache',
        method: 'POST',
        data
    })
}

// 招录数据大小年投档分对比导出
export const importZLRank = data => {
    return axios({
        url: '/api/data/wish/optimize/predict/rank',
        method: 'POST',
        data
    })
}

// 位次转分数
export const importZLScoreRank = data => {
    return axios({
        url: '/api/data/wish/make/predict/rank/score',
        method: 'POST',
        data
    })
}

// 获取招录数据日志
export const getAdmissionLog = data => {
    return axios({
        url: '/api/data/wish/admission/log',
        method: 'GET',
        data
    })
}

// 招录数据日志对比
export const compareLog = data => {
    return axios({
        url: '/api/data/wish/admission/log/compare',
        method: 'GET',
        data
    })
}

// 导出日志
export const exportLog = data => {
    return axios({
        url: '/api/data/wish/admission/log/export',
        method: 'POST',
        data
    })
}

// 一分一段表导入
export const importParagraph = data => {
    return axios({
        url: '/api/data/wish/base/segment/convert',
        method: 'POST',
        data
    })
}

// 招录数据批量检测相似专业
export const checkSameProf = data => {
    return axios({
        url: '/api/data/wish/admission/school/prof/check',
        method: 'POST',
        data
    })
}


// 获取志愿用户数据日志列表
export const getUserLimitLog = data => {
    return axios({
        url: '/api/admin/wish/user/limit/log',
        method: 'GET',
        data
    })
}

// 志愿用户数据日志对比
export const UserLimitCompare = data => {
    return axios({
        url: '/api/admin/wish/user/limit/log/compare',
        method: 'GET',
        data
    })
}

// 招录数据批量更新位次
export const updateRank = data => {
    return axios({
        url: '/api/data/wish/admission/update/rank',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/zlinfo.js